import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import useProtecaoDeRota from '../hooks/useProtecaoDeRota';
import { Spin, message } from 'antd';
import TabelaDados from '../componentes/Table';
import useApi from '../hooks/useApi';


const PaginaLog = () => {
  const verificando = useProtecaoDeRota();
  const [usuarios, setUsuarios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const previousUsuariosRef = useRef([]); // Ref para armazenar dados anteriores

  const { callApi } = useApi('https://vision.alfama.com/api/view/usuarios/logs', {
    includeToken: true,
  });

  const extraColumns = useMemo(() => [
    { id: 'nome', name: 'Nome', sort: true, mwidth: '5%' },
    { id: 'nome_usuario', name: 'Usuario', sort: true, mwidth: '10%' },

    { id: 'tipo_usuario', name: 'Tipo', sort: true, width: '10%' },
    { id: 'nome_departamento', name: 'Departamento', sort: true, width: '15%' },
    { id: 'ip_acesso', name: 'IP Acesso', sort: true, width: '15%' },
    { id: 'horario_entrada', name: 'Data', sort: true, width: '15%' },
  ], []);

  const showMessage = useCallback((type, content) => {
    message[type](content);
  }, []);

  const formatarUsuarios = useCallback((dados) => {
    return dados.map(usuario => ({
      id: usuario.log_id,
      nome: usuario.nome_pessoa,
      nome_usuario: usuario.nome_usuario,

      status: usuario.status_login,
      tipo_usuario: usuario.tipo_usuario,
      nome_departamento: usuario.departamento,

      horario_entrada: usuario.data_login,

      ip_acesso: usuario.ip_acesso,
    }));
  }, []);

  const buscarUsuarios = useCallback(async () => {
    try {
      const resultado = await callApi();
      const usuariosFormatados = formatarUsuarios(resultado);

      // Verifica se os dados mudaram
      if (JSON.stringify(usuariosFormatados) !== JSON.stringify(previousUsuariosRef.current)) {
        setUsuarios(usuariosFormatados);
        previousUsuariosRef.current = usuariosFormatados; // Atualiza os dados anteriores
      }
    } catch (erro) {
      console.error('Erro ao buscar usuários:', erro);
      showMessage('error', 'Não foi possível carregar os usuários');
    } finally {
      setIsLoading(false);
    }
  }, [callApi, formatarUsuarios, showMessage]);

  const handleModalOpen = useCallback((type, id) => {
    setModalType(type);
    setSelectedId(id);
    setModalVisible(true);
  }, []);


  useEffect(() => {
    if (!verificando) {
      buscarUsuarios();
    }

    const intervalId = setInterval(() => {
      buscarUsuarios(); // Atualiza os usuários a cada 5 minutos
    }, 300000); // Atualização a cada 5 minutos

    return () => {
      clearInterval(intervalId);
    };
  }, [buscarUsuarios, verificando]);

 

  return (
    <>
      <TabelaDados
        data={usuarios}
        extraColumns={extraColumns}
        onModalOpen={handleModalOpen}
        editarvisualizar={false}
        excluirvisualizar={false}
        adicionarvisualizar={false}
      />

    </>
  );
};

export default PaginaLog;